import { EVENTS, publish } from 'ia-util-pubsub'

class IaQtyPicker extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.js-qty-picker')
    this.plusButton = this.querySelector('.js-plus')
    this.minusButton = this.querySelector('.js-minus')
    this.setupEventListeners()
  }

  get min() {
    return parseInt(this.getAttribute('min')) ?? 1
  }

  get max() {
    return parseInt(this.getAttribute('max')) || Infinity
  }

  setupEventListeners() {
    this.plusButton?.addEventListener('click', () => {
      const currentValue = parseInt(this.value)
      console.log('currentValue', currentValue);
      const newValue = Math.min(isNaN(currentValue) ? 0 : currentValue + 1, this.max)
      if (newValue !== parseInt(this.value)) {
        this.value = newValue
        this.input.value = newValue
        this.publishQtyChange()
      }
    })

    this.minusButton?.addEventListener('click', () => {
      const currentValue = parseInt(this.value)
      const newValue = Math.max(isNaN(currentValue) ? 0 : currentValue - 1, this.min)
      if (newValue !== parseInt(this.value)) {
        this.value = newValue
        this.input.value = newValue
        this.publishQtyChange()
      }
    })

    this.input?.addEventListener('change', (event) => {
      const newValue = parseInt(event.target.value)
      if (isNaN(newValue)) {
        this.value = this.min
        this.input.value = this.min
      } else {
        const boundedValue = Math.min(Math.max(newValue, this.min), this.max)
        this.value = boundedValue
        this.input.value = boundedValue
      }
      this.publishQtyChange()
    })

    this.input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault()
        event.target.blur()
      }
    })
  }

  publishQtyChange() {
    publish(EVENTS.qtyChange, {
      detail: {
        value: this.value,
        name: this.name,
        id: this.dataset.id,
      }
    })
  }

  get value() {
    const attrValue = this.getAttribute('value')
    if (attrValue !== null) return attrValue
    if (this.input?.value !== undefined) return this.input.value
    return String(this.min)
  }

  set value(val) {
    this.setAttribute('value', val)
  }

  get name() {
    return this.input?.name || ''
  }

}

customElements.define('ia-product-qty', IaQtyPicker) 